
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.525 22.419l-22-13.007C16.738 8.357 14 9.383 14 11.994V38c0 2.344 2.544 3.756 4.525 2.581l22-13c1.962-1.156 1.969-4.006 0-5.162z","fill":"#535353"}})])
          )
        }
      }
    